// extracted by mini-css-extract-plugin
export default {"backlogMessage":"index_backlogMessage__xen2r","table-toolbar":"index_table-toolbar__64Jy4","left":"index_left__V6Wv9","right":"index_right__EEtFw"};